import React from 'react';

import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { Button } from '../../../components-core/packages/components-core/dist/button/index';
import { Link } from '../../../components-core/packages/components-core/dist/link/index';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { 
    Container, 
    ContainerGutter, 
    ContainerWrap,
    ContainerHorizontalAlignment, 
    ContainerVerticalAlignment,
    ContainerPadding
} from '../../../components-core/packages/components-core/dist/container/index';

import {
    ThemeProvider,
    styled
} from '../../../components-core/packages/components-core/dist/theme-provider/index';
import {
    Text,
    TextAppearance,
    TextColor,
    TextAlignment,
} from '../../../components-core/packages/components-core/dist/text/index';
import { Image } from '../../../components-core/packages/components-core/dist/image/index';



const ColorContainer = styled.div`
    background-color: ${props => props.backgroundColor};
    min-height: 180px;
    padding-top: 24px;
    width: 100%;
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 24px;
`;

const CenterContentContainer = styled(ContentContainer)`
    align-items: center;
`;

const ImageContainer = styled.div`
    margin-top: -22%;
`;

const TextContainer = styled.div`
    padding: 0 32px 0 32px;
`; 

class MaintenancePrice extends React.Component {

    renderPrice() {
        return (
            <Text textAlign={TextAlignment.center}  appearance={TextAppearance.label0200} >
                <b>{this.props.data.price}</b>'den başlayan fiyatlarla
            </Text>  
        )
    }

    renderModeOne() {
        return (
            <CenterContentContainer>
                {this.renderPrice()}
            </CenterContentContainer>
        )
    }
    
    render() {
        return [
            <ThemeProvider theme={'image'}>
                <ColorContainer backgroundColor={this.props.data.backgroundColor}>
                    <TextContainer>
                        <Text bold appearance={TextAppearance.headline0250}>
                            {this.props.data.title}
                        </Text>
                    </TextContainer>
                </ColorContainer>
            </ThemeProvider>,
            <ThemeProvider theme={'main'} >
                <ImageContainer>
                    <Image 
                        src={this.props.data.image}
                        alt={this.props.data.title}
                    />
                </ImageContainer>
                {this.renderModeOne()}
            </ThemeProvider>
        ]
    }

}
export default MaintenancePrice;